import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import type { CreateCardFormValues } from './types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getDefaultValues } from './data';
import { createCardFormSchema } from './validation';
import { useCardHolderName } from '@/entities/card';
import { useUserProfileInfo } from '@/entities/user';

type Props = {
  initialValues?: Partial<CreateCardFormValues>;
};

export const useCreateCardForm = ({ initialValues }: Props) => {
  const { t } = useTranslation();

  const { userProfileInfoMap } = useUserProfileInfo();
  const { cardHolderName } = useCardHolderName({
    firstName: userProfileInfoMap.firstName,
    lastName: userProfileInfoMap.lastName,
  });

  const validationSchema = useMemo(() => createCardFormSchema(t), [t]);

  const form = useForm<CreateCardFormValues>({
    mode: 'onChange',
    resolver: zodResolver(validationSchema),
    defaultValues: getDefaultValues({ cardHolderName, initialValues }),
  });

  return {
    form,
  };
};
